import React from 'react';
import { Link } from 'react-router-dom';

const TelephoneSurveyLeadsPage = () => {
  return (
    <div>
      {/* Article Header */}
      <section
        className="h-[42vh] sm:h-[49vh] md:h-[56vh] bg-cover bg-center bg-no-repeat relative"
        style={{
          backgroundImage: "url('/images/tele-survey-leads-for-sales-team.webp')"
        }}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
        />

        {/* Banner Content */}
        <div className="relative z-10 flex items-center h-full px-4 sm:px-8 md:px-16 lg:px-24">
          <div className="text-center text-white max-w-6xl mx-auto">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-4 sm:mb-6 leading-tight text-white">
              Telephone survey leads [how to use them in your strategy]
            </h1>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-8 sm:py-10 md:py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="blog_inner">
            <div className="blog_lift_sidebar">
              <div className="blog_items">
                <div className="prose prose-lg max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    We're pleased to announce that telephone survey leads are back by popular demand. With the rise of online surveys, tele surveys still remain one of the most successful ways to gather pre-qualified leads for your sales team, and are also a staple product delivered by Lloyd James for several years.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    Target serious buyers and relevant consumers – with tele survey leads you will provide your sales team with more qualified prospects<strong>.</strong>
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    When done properly, telephone survey leads mean you can contact your customers on a personal level. Therefore will receive a constant stream of new prospects at a relatively low cost.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    How does it work?
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Interviewing is carried out by telephone operators which generates leads which not only fully-opt in, customers are also categorized into buckets labelled with specific interests. The data is then used to create a dataset which matches your required demographic, ensuring you get the highest sales closure rate. It can be highly flexible and the range of data available from this method is vast.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Contact one of our data experts today <Link to="/contact" className="text-pink-600 hover:text-pink-700 underline" onClick={() => window.scrollTo(0, 0)}>click here</Link> to learn more about leads from telephone surveys.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    The difference with tele survey leads is call agents are speaking actively with the consumers and asking the questions you want answering, this will ensure your sales team get qualified leads that lead to a higher conversion rate.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    How to implement tele survey leads to your sales strategy
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    There are multiple profiling options available to ensure you target customers who fit your criteria, including:
                  </p>

                  <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6 text-base">
                    <li className="mb-1">Residential Status</li>
                    <li className="mb-1">Age</li>
                    <li className="mb-1">Marital Status</li>
                    <li className="mb-1">Employment Status</li>
                    <li className="mb-1">Location</li>
                    <li className="mb-1">Contact channel preference</li>
                    <li className="mb-1">Your bespoke question set</li>
                  </ul>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    The criteria you set is applied to your campaign to ensure anything out of criteria is rejected before it reaches you. Businesses who receive tele survey leads operate very differently when the data is received, some dial manually, some use other forms of online marketing and lead generation strategies.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    If you don't have the resource to cold call each and every client in your data list, survey leads are the solution for you. Any piece of information that you need is practically at your fingertips.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TelephoneSurveyLeadsPage;